import Application from "../../Application";
import withStore, {
  TLoadingAwarePresenter,
  TPresentable
} from "../../core/presenter/withStore";
import { IIndexTypeCategory } from "../model/IndexTypeCategory";
import { IIndexTypeGroup } from "../model/IndexTypeGroup";
import IndexTypeGroupPresentationModel, {
  TIndexTypeGroupPresentationModel
} from "./model/IndexTypeGroupPresentationModel";

export interface TIndexTypeGroupDetailsPresenter
  extends TLoadingAwarePresenter {
  indexTypeGroup: TIndexTypeGroupPresentationModel;
  categories: IIndexTypeCategory[];
}
export interface IIndexTypeGroupDetailsPresenter
  extends TIndexTypeGroupDetailsPresenter,
    TPresentable {
  loadIndexTypeGroupDetails(indexTypes: IIndexTypeGroup): void;
  loadReferenceValues(categories: IIndexTypeCategory[]): void;
}
const defaultState: TIndexTypeGroupDetailsPresenter = {
  indexTypeGroup: {} as TIndexTypeGroupPresentationModel,
  categories: []
};
const IndexTypeGroupDetailsPresenter = withStore<
  IIndexTypeGroupDetailsPresenter,
  TIndexTypeGroupDetailsPresenter
>(
  ({
    application,
    store,
    loader,
    translate
  }): IIndexTypeGroupDetailsPresenter => {
    const _store = store;
    const _application: Application = application;
    const state = _store.getState<TIndexTypeGroupDetailsPresenter>();
    const loadReferenceValues = (categories: IIndexTypeCategory[]) => {
      _store.update({ categories });
    };
    loader.start("indexTypeGroupLoader");
    const loadIndexTypeGroupDetails = (indexType: IIndexTypeGroup) => {
      const { categories } = _store.getState<TIndexTypeGroupDetailsPresenter>();

      let indexTypeGroup = IndexTypeGroupPresentationModel(
        indexType,
        categories
      );
      _store.update({
        indexTypeGroup,
        breadCrumb: {
          id: () => indexTypeGroup?.name
        }
      });
      loader.stop("indexTypeGroupLoader");
    };

    return {
      ...state,
      store: _store,
      loader,
      application: _application,
      translate,
      loadIndexTypeGroupDetails,
      loadReferenceValues
    };
  },
  defaultState
);
export default IndexTypeGroupDetailsPresenter;
